// Openbook jazz lead sheets (github.com/veltzer/openbook — GPL-licensed
// LilyPond typesettings): the bundled .ly.mako sources, parsed at load time
// by src/music/openbook/parse.ts. These double as the importer's test
// fixtures. Personal-project ruling (July 2026): the repo is private and the
// deploy URL unlisted, so converted tunes may ship in the bundle — revisit
// before any public release.
import fiveHundredMilesHigh from '../music/openbook/fixtures/500_miles_high.ly.mako?raw';
import aCupOfCoffee from '../music/openbook/fixtures/a_cup_of_coffee_a_sandwich_and_you.ly.mako?raw';
import aDayInTheLife from '../music/openbook/fixtures/a_day_in_the_life_of_a_fool.ly.mako?raw';
import aFineRomance from '../music/openbook/fixtures/a_fine_romance.ly.mako?raw';
import aFoggyDay from '../music/openbook/fixtures/a_foggy_day.ly.mako?raw';
import bluesForAlice from '../music/openbook/fixtures/blues_for_alice.ly.mako?raw';
import donnaLee from '../music/openbook/fixtures/donna_lee.ly.mako?raw';

export interface OpenbookEntry {
  id: string;
  label: string;
  src: string;
  /** Basename in public/openbook/ (the full-corpus manifest lists the same
   *  file; the dropdown dedupes on it so bundled favourites appear once). */
  file: string;
}

export const OPENBOOK_TUNES: OpenbookEntry[] = [
  { id: '500-miles-high', label: '500 Miles High', src: fiveHundredMilesHigh, file: '500_miles_high.ly.mako' },
  { id: 'cup-of-coffee', label: 'A Cup Of Coffee, A Sandwich And You', src: aCupOfCoffee, file: 'a_cup_of_coffee_a_sandwich_and_you.ly.mako' },
  { id: 'day-in-the-life-fool', label: 'A Day In The Life Of A Fool', src: aDayInTheLife, file: 'a_day_in_the_life_of_a_fool.ly.mako' },
  { id: 'fine-romance', label: 'A Fine Romance', src: aFineRomance, file: 'a_fine_romance.ly.mako' },
  { id: 'foggy-day', label: 'A Foggy Day', src: aFoggyDay, file: 'a_foggy_day.ly.mako' },
  { id: 'blues-for-alice', label: 'Blues For Alice', src: bluesForAlice, file: 'blues_for_alice.ly.mako' },
  { id: 'donna-lee', label: 'Donna Lee', src: donnaLee, file: 'donna_lee.ly.mako' },
];
